import { renderCardFooter_unstable } from '@fluentui/react-card';

/**
 * Renders the final JSX of the CardFooter component, given the state.
 */
export const renderCardFooter = renderCardFooter_unstable;
